/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from 'app/app.config';
import { setupDynamicViewportHeightFallbackUnitCalculator } from '@styleguide/dvh/dvh-css-unit-fallback';

if (environment.production) {
  enableProdMode();
}

setupDynamicViewportHeightFallbackUnitCalculator();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
